import { HorizontalMenuService } from '@/layout/service/horizontal-menu.service';
import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  viewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'store-horizontal-menu-item',
  imports: [MatIconModule, MatButtonModule, MatMenuModule, NgClass],
  templateUrl: './horizontal-menu-item.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalMenuItemComponent {
  protected horMenuSrv = inject(HorizontalMenuService);

  handle = input.required<string>();
  isRootNode = input(false);
  itemCssClass = input<string>();

  rootTrigger = viewChild<MatMenuTrigger>('rootTrigger');
  forceMenuClosing = output<boolean>();

  item = computed(() => this.horMenuSrv.getItemByHandle(this.handle()));
  childNodes = computed(() => {
    const childHandles = this.horMenuSrv.getNode(this.handle());
    if (childHandles) {
      return childHandles?.map(handle => ({
        ...this.horMenuSrv.getItemByHandle(handle),
        expandable: this.horMenuSrv.isExpandable(handle),
      }));
    }
    return null;
  });
  isExpandable = computed(() => this.horMenuSrv.isExpandable(this.handle()));

  protected onClickItem(handle: string) {
    const item = this.horMenuSrv.getItemByHandle(handle);
    if (item) this.horMenuSrv.selectItem(item);
  }

  closeMenu() {
    if (this.isRootNode()) {
      this.rootTrigger()?.closeMenu();
    } else {
      this.forceMenuClosing.emit(true);
    }
  }
}
